import { render, staticRenderFns } from "./showProfilesComponent.vue?vue&type=template&id=8528e1f0"
import script from "./showProfilesComponent.vue?vue&type=script&lang=js"
export * from "./showProfilesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports